import React, { Component } from 'react';
import { GraphView } from 'react-digraph';
import "./index.css";
  
const GraphConfig =  {
    NodeTypes: {
        tableNode: { // required to show empty nodes
            typeText: "Table",
            shapeId: "#tableNode", // relates to the type property of a node
            shape: (
            <symbol viewBox="0 0 200 100" id="tableNode" key="0">
                <rect width="200" height="100" rx="4" fill="var(--color-line)"></rect>
            </symbol>
            )
        },
    },
    NodeSubtypes: {},
    EdgeTypes: {
        composeEdge: {  // required to show empty edges
            shapeId: "#composeEdge",
            shape: (
            <symbol viewBox="0 0 50 50" id="composeEdge" key="0">
                <circle cx="25" cy="25" r="8" fill="currentColor"> </circle>
            </symbol>
            )
        }
    }
};
  
const NODE_KEY = "id";      // Allows D3 to correctly update DOM
  
export default class Graph extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selected: {}
      }
      this.onSelectNode = this.onSelectNode.bind(this);
      this.renderNodeText = this.renderNodeText.bind(this);
    }
  
    /* Define custom graph editing methods here */
    renderNodeText(data, id, isSelected) {
        const tableElemement = data?.full_table_id?.split('.')
        const datasetId = `${tableElemement[0]}.${tableElemement[1]}`;
        return (
            <text className="node-text" text-anchor="middle">
                <tspan x="0" dy="0" fontSize="14px" font-weight="bold">
                    {data.code_name}
                </tspan>
                <tspan x="0" dy="1.8em" fontSize="10px" opacity="0.5">
                    {datasetId}
                </tspan>
            </text>
        );
    }
    onSelectNode(node) {
        console.log('Selected node', node);
        if (node.table_internal_id) {
            window.location.href = `/table/${node.table_internal_id}`;
        }
    }
  
    render() {
        const { graph, readOnly } = this.props;
        if (!graph) return null;
        const nodes = graph.nodes;
        const edges = graph.edges;
        const selected = this.state.selected;
    
        const NodeTypes = GraphConfig.NodeTypes;
        const NodeSubtypes = GraphConfig.NodeSubtypes;
        const EdgeTypes = GraphConfig.EdgeTypes;
    
        return (
            <div id='graph' className={`transformation-graph__container ${nodes.length > 6 ? 'transformation-graph__container_high' : ''}`}>
                <GraphView
                    ref='GraphView'
                    layoutEngineType="VerticalTree"
                    nodeLocationOverrides
                    readOnly={readOnly}
                    minZoom={0.5}
                    edgeHandleSize={0}
                    maxTitleChars={300}
                    nodeKey={NODE_KEY}
                    nodes={nodes}
                    edges={edges}
                    selected={selected}
                    nodeTypes={NodeTypes}
                    nodeSubtypes={NodeSubtypes}
                    edgeTypes={EdgeTypes}
                    onSelectNode={this.onSelectNode}
                    onCreateNode={this.onCreateNode}
                    onUpdateNode={this.onUpdateNode}
                    onDeleteNode={this.onDeleteNode}
                    onSelectEdge={this.onSelectEdge}
                    onCreateEdge={this.onCreateEdge}
                    onSwapEdge={this.onSwapEdge}
                    onDeleteEdge={this.onDeleteEdge}
                    renderNodeText={this.renderNodeText}
                />
            </div>
        );
    }
  
}